import { cB as e, cM as t, c as i } from "./ghl-ui.es361.js";
const r = e("icon", `
 height: 1em;
 width: 1em;
 line-height: 1em;
 text-align: center;
 display: inline-block;
 position: relative;
 fill: currentColor;
 transform: translateZ(0);
`, [t("color-transition", {
  transition: "color .3s var(--n-bezier)"
}), t("depth", {
  color: "var(--n-color)"
}, [i("svg", {
  opacity: "var(--n-opacity)",
  transition: "opacity .3s var(--n-bezier)"
})]), i("svg", {
  height: "1em",
  width: "1em"
})]);
export {
  r as default
};
